// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import * as XLSX from "xlsx";
// import {
//   FaPhoneAlt,
//   FaSearch,
//   FaFileDownload,
//   FaUserFriends,
//   FaHandshake,
//   FaShoppingCart,
//   FaChartBar,
// } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// function UnitSQYDLedger() {
//   const [mobile, setMobile] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [searchDetails, setSearchDetails] = useState(null);
//   const [summary, setSummary] = useState(null);

//   const getAuthToken = () => localStorage.getItem("token");

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     if (dateStr.includes("-")) {
//       const parts = dateStr.split("-");
//       if (
//         parts[0].length === 2 &&
//         parts[1].length === 2 &&
//         parts[2].length === 4
//       ) {
//         return `${parts[0]}/${parts[1]}/${parts[2]}`;
//       }
//     }
//     try {
//       const date = new Date(dateStr);
//       if (!isNaN(date)) {
//         return date.toLocaleDateString("en-IN", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//         });
//       }
//     } catch (e) {
//       return dateStr;
//     }
//     return dateStr;
//   };

//   const fetchData = async (e) => {
//     e.preventDefault();
//     if (!mobile) {
//       Swal.fire("Missing Input", "Please enter a mobile number", "warning");
//       return;
//     }

//     setLoading(true);
//     setTableData([]);
//     setSearchDetails(null);
//     setSummary(null);

//     try {
//       const token = getAuthToken();
//       const response = await axios.get(
//         `${API_URL}/myteam-tree-with-sales?mobile=${mobile}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       if (response.data.status === "1") {
//         setSearchDetails(response.data.search_details);

//         const apiSummary = response.data.summary || {};
//         setSummary({
//           total_users_in_tree: apiSummary.total_users || 0,
//           users_with_transactions: apiSummary.users_with_transactions || 0,
//           total_direct_sales: 0,
//           total_commissions: 0,
//         });

//         const formattedData = [];
//         const userData = response.data.user_data;

//         if (
//           userData &&
//           userData.transactions &&
//           userData.transactions.all_transactions
//         ) {
//           const allTransactions = userData.transactions.all_transactions;
//           let directSalesCount = 0;
//           let commissionsCount = 0;

//           allTransactions.forEach((transaction) => {
//             const isSelf = transaction.entry_type === "self";
//             const isTeam = transaction.entry_type === "team";

//             if (isSelf) directSalesCount++;
//             if (isTeam) commissionsCount++;

//             const transactionDate =
//               transaction.date ||
//               transaction.display_date ||
//               transaction.lead_date ||
//               new Date().toISOString().split("T")[0];

//             formattedData.push({
//               srNo: formattedData.length + 1,
//               parentName: userData.parent_username || "-",
//               parentMobile: userData.parent_mobile || "-",
//               project_name: transaction.project_name || "-",
//               blockNo: transaction.block_name || "-",
//               unitNo: transaction.unit_no || "-",
//               unitSqyd: transaction.plot_area || "0.00",
//               associateName: transaction.child_username || "-",
//               associateMobile: transaction.child_mobile || "-",
//               customer_name: transaction.customer_name || "-",
//               customer_mobile: transaction.customer_mobile || "-",
//               levelNo: userData.level_in_tree || 0,
//               oldSqyd: transaction.old_sqyd || 0,
//               new_sqyd: transaction.new_sqyd || 0,
//               currentSqyd: transaction.plot_area || 0,
//               totalSqyd: transaction.new_sqyd || 0,
//               date: transactionDate,
//               type: isSelf ? "Direct Sale" : "Commission",
//               entryType: transaction.entry_type,
//             });
//           });

//           setSummary((prev) => ({
//             ...prev,
//             total_direct_sales: directSalesCount,
//             total_commissions: commissionsCount,
//           }));
//         }

//         const sortedData = [...formattedData].sort((a, b) => {
//           const valA = parseFloat(a.new_sqyd) || 0;
//           const valB = parseFloat(b.new_sqyd) || 0;
//           return valA - valB;
//         });

//         setTableData(sortedData);
//       } else {
//         Swal.fire("No Data", response.data.message || "No data found", "info");
//       }
//     } catch (error) {
//       console.error("Data fetch error:", error);
//       Swal.fire(
//         "Warning !!!",
//         "Sorry No Data Found Please Try Another.",
//         "info"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const downloadExcel = () => {
//     if (tableData.length === 0) {
//       Swal.fire("No Data", "No data available to download", "warning");
//       return;
//     }

//     const excelData = tableData.map((row, index) => ({
//       "Sr No": index + 1,
//       Date: row.date,
//       "Parent Name": row.parentName,
//       "Parent Mobile": row.parentMobile || "NA",
//       "Project Name": row.project_name,
//       "Block No": row.blockNo || "NA",
//       "Unit No": row.unitNo,
//       "Unit SQYD": parseFloat(row.unitSqyd).toFixed(2),
//       "Associate Name": row.associateName,
//       "Associate Mobile": row.associateMobile,
//       "Customer Name": row.customer_name || "NA",
//       "Customer Mobile": row.customer_mobile || "NA",
//       "Level No": row.levelNo,
//       "Old SQYD": parseFloat(row.oldSqyd).toFixed(2),
//       "Current SQYD": parseFloat(row.unitSqyd).toFixed(2),
//       "Total SQYD": parseFloat(row.new_sqyd).toFixed(2),
//       "Transaction Type": row.type,
//     }));

//     const ws = XLSX.utils.json_to_sheet(excelData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Unit SQYD Ledger");
//     const fileName = `Unit_SQYD_Ledger_${mobile}_${
//       new Date().toISOString().split("T")[0]
//     }.xlsx`;
//     XLSX.writeFile(wb, fileName);
//     Swal.fire("Success", "Excel file downloaded successfully!", "success");
//   };

//   const summaryCards = summary
//     ? [
//         {
//           label: "Total Users",
//           value: summary.total_users_in_tree,
//           icon: <FaUserFriends />,
//           color: "#1e5799",
//           bg: "#e8f1fb",
//         },
//         {
//           label: "With Transactions",
//           value: summary.users_with_transactions,
//           icon: <FaHandshake />,
//           color: "#d97706",
//           bg: "#fef3e2",
//         },
//         {
//           label: "Direct Sales",
//           value: summary.total_direct_sales,
//           icon: <FaShoppingCart />,
//           color: "#059669",
//           bg: "#e7f9eb",
//         },
//         {
//           label: "Commissions",
//           value: summary.total_commissions,
//           icon: <FaChartBar />,
//           color: "#7c3aed",
//           bg: "#f3e8ff",
//         },
//       ]
//     : [];

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
//         <div
//           style={{
//             background: "#ffffff",
//             borderRadius: "20px",
//             boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//             border: "1.5px solid #e2e8f0",
//             overflow: "hidden",
//           }}
//         >
//           {/* Top Gradient Bar */}
//           <div
//             style={{
//               height: "5px",
//               background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//             }}
//           />

//           {/* Header */}
//           <div
//             style={{
//               padding: "24px 30px",
//               background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//               borderBottom: "1.5px solid #e2e8f0",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 <FaChartBar />
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   Unit SQYD Ledger Report
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Search by mobile number to view SQYD transactions
//                 </p>
//               </div>
//             </div>

//             {tableData.length > 0 && (
//               <button
//                 onClick={downloadExcel}
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   padding: "10px 20px",
//                   borderRadius: "10px",
//                   border: "none",
//                   background: "linear-gradient(135deg, #059669, #047857)",
//                   color: "#ffffff",
//                   fontSize: "13px",
//                   fontWeight: "700",
//                   cursor: "pointer",
//                   boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
//                   transition: "all 0.25s ease",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = "translateY(-2px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 10px 24px rgba(5, 150, 105, 0.45)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow =
//                     "0 6px 18px rgba(5, 150, 105, 0.3)";
//                 }}
//               >
//                 <FaFileDownload style={{ fontSize: "14px" }} />
//                 Download Excel
//               </button>
//             )}
//           </div>

//           {/* Body */}
//           <div style={{ padding: "24px 30px" }}>
//             {/* Search Form */}
//             <form
//               onSubmit={fetchData}
//               style={{
//                 background: "#f8fafc",
//                 borderRadius: "14px",
//                 padding: "18px",
//                 marginBottom: "24px",
//                 border: "1.5px solid #e2e8f0",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "12px",
//                   alignItems: "flex-end",
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <div style={{ flex: 1, minWidth: "240px" }}>
//                   <label
//                     style={{
//                       display: "block",
//                       fontSize: "12.5px",
//                       fontWeight: "700",
//                       color: "#1e3a5f",
//                       marginBottom: "6px",
//                     }}
//                   >
//                     Mobile Number <span style={{ color: "#dc2626" }}>*</span>
//                   </label>
//                   <div style={{ position: "relative" }}>
//                     <span
//                       style={{
//                         position: "absolute",
//                         left: "12px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         color: "#1e5799",
//                         fontSize: "14px",
//                         pointerEvents: "none",
//                       }}
//                     >
//                       <FaPhoneAlt />
//                     </span>
//                     <input
//                       type="text"
//                       placeholder="Enter 10-digit mobile number"
//                       value={mobile}
//                       onChange={(e) =>
//                         setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
//                       }
//                       style={{
//                         width: "100%",
//                         padding: "11px 14px 11px 38px",
//                         borderRadius: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         background: "#ffffff",
//                         fontSize: "13.5px",
//                         fontWeight: "500",
//                         color: "#1e3a5f",
//                         outline: "none",
//                         boxSizing: "border-box",
//                         transition: "all 0.25s ease",
//                       }}
//                       onFocus={(e) => {
//                         e.target.style.borderColor = "#1e5799";
//                         e.target.style.boxShadow =
//                           "0 0 0 4px rgba(30,87,153,0.1)";
//                       }}
//                       onBlur={(e) => {
//                         e.target.style.borderColor = "#e2e8f0";
//                         e.target.style.boxShadow = "none";
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   style={{
//                     padding: "11px 30px",
//                     borderRadius: "10px",
//                     border: "none",
//                     background: loading
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                     color: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "700",
//                     cursor: loading ? "not-allowed" : "pointer",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
//                     transition: "all 0.25s ease",
//                     height: "44px",
//                   }}
//                 >
//                   {loading ? (
//                     <>
//                       <span
//                         style={{
//                           width: "14px",
//                           height: "14px",
//                           border: "2px solid rgba(255,255,255,0.3)",
//                           borderTop: "2px solid #ffffff",
//                           borderRadius: "50%",
//                           display: "inline-block",
//                           animation: "spin 0.8s linear infinite",
//                         }}
//                       />
//                       Loading...
//                     </>
//                   ) : (
//                     <>
//                       <FaSearch style={{ fontSize: "13px" }} />
//                       Show Details
//                     </>
//                   )}
//                 </button>
//               </div>
//             </form>

//             {/* Search Details */}
//             {searchDetails && (
//               <div
//                 style={{
//                   background:
//                     "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   borderRadius: "14px",
//                   padding: "16px 22px",
//                   marginBottom: "20px",
//                   color: "#ffffff",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "14px",
//                   flexWrap: "wrap",
//                   boxShadow: "0 8px 24px rgba(30, 87, 153, 0.25)",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "42px",
//                     height: "42px",
//                     borderRadius: "12px",
//                     background: "rgba(255,255,255,0.2)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "20px",
//                     flexShrink: 0,
//                   }}
//                 >
//                   👤
//                 </div>
//                 <div>
//                   <p
//                     style={{
//                       margin: 0,
//                       fontSize: "11px",
//                       opacity: 0.85,
//                       fontWeight: "600",
//                       textTransform: "uppercase",
//                       letterSpacing: "1px",
//                     }}
//                   >
//                     Search Result
//                   </p>
//                   <h5
//                     style={{
//                       margin: "2px 0 0",
//                       fontSize: "16px",
//                       fontWeight: "800",
//                     }}
//                   >
//                     {searchDetails.username} — {searchDetails.mobile}
//                     {searchDetails.has_transactions && (
//                       <span
//                         style={{
//                           marginLeft: "10px",
//                           fontSize: "11px",
//                           padding: "3px 10px",
//                           borderRadius: "20px",
//                           background: "rgba(255,255,255,0.25)",
//                           fontWeight: "700",
//                         }}
//                       >
//                         ✓ Has Transactions
//                       </span>
//                     )}
//                   </h5>
//                 </div>
//               </div>
//             )}

//             {/* Summary Cards */}
//             {summary && (
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(4, 1fr)",
//                   gap: "14px",
//                   marginBottom: "24px",
//                 }}
//               >
//                 {summaryCards.map((card, i) => (
//                   <div
//                     key={i}
//                     style={{
//                       background: "#ffffff",
//                       borderRadius: "14px",
//                       padding: "18px",
//                       border: "1.5px solid #e2e8f0",
//                       position: "relative",
//                       overflow: "hidden",
//                       boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
//                       transition: "all 0.3s ease",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = "translateY(-4px)";
//                       e.currentTarget.style.boxShadow =
//                         "0 12px 28px rgba(30, 87, 153, 0.15)";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow =
//                         "0 4px 14px rgba(30, 87, 153, 0.06)";
//                     }}
//                   >
//                     <div
//                       style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         width: "4px",
//                         height: "100%",
//                         background: card.color,
//                       }}
//                     />
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "flex-start",
//                       }}
//                     >
//                       <div style={{ flex: 1 }}>
//                         <p
//                           style={{
//                             fontSize: "11.5px",
//                             fontWeight: "700",
//                             color: "#64748b",
//                             margin: 0,
//                             textTransform: "uppercase",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           {card.label}
//                         </p>
//                         <h3
//                           style={{
//                             fontSize: "24px",
//                             fontWeight: "800",
//                             color: card.color,
//                             margin: "8px 0 0",
//                             letterSpacing: "-0.5px",
//                           }}
//                         >
//                           {card.value}
//                         </h3>
//                       </div>
//                       <div
//                         style={{
//                           width: "40px",
//                           height: "40px",
//                           borderRadius: "10px",
//                           background: card.bg,
//                           color: card.color,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontSize: "18px",
//                           flexShrink: 0,
//                         }}
//                       >
//                         {card.icon}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* Table */}
//             {tableData.length > 0 && (
//               <div
//                 style={{
//                   overflowX: "auto",
//                   borderRadius: "14px",
//                   border: "1.5px solid #e2e8f0",
//                 }}
//               >
//                 <table
//                   style={{
//                     width: "100%",
//                     borderCollapse: "collapse",
//                     fontSize: "12.5px",
//                   }}
//                 >
//                   <thead>
//                     <tr
//                       style={{
//                         background:
//                           "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       }}
//                     >
//                       {[
//                         "Sr No",
//                         "Date",
//                         "Parent Name",
//                         "Parent Mobile",
//                         "Customer Name",
//                         "Customer Mobile",
//                         "Project",
//                         "Block",
//                         "Unit",
//                         "Unit SQYD",
//                         "Associate Name",
//                         "Associate Mobile",
//                         "Level",
//                         "Old SQYD",
//                         "Current SQYD",
//                         "Total SQYD",
//                         "Type",
//                       ].map((th, i) => (
//                         <th
//                           key={i}
//                           style={{
//                             padding: "12px 10px",
//                             color: "#ffffff",
//                             fontWeight: "700",
//                             fontSize: "11px",
//                             textAlign: "left",
//                             letterSpacing: "0.5px",
//                             textTransform: "uppercase",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {th}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {tableData.map((row, index) => (
//                       <tr
//                         key={index}
//                         style={{
//                           borderBottom: "1px solid #f1f5f9",
//                           transition: "background 0.2s ease",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.background = "#f8fafc")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.background = "transparent")
//                         }
//                       >
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "700",
//                             color: "#1e5799",
//                           }}
//                         >
//                           {index + 1}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             color: "#64748b",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {formatDate(row.date)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "600",
//                             color: "#1e3a5f",
//                           }}
//                         >
//                           {row.parentName || "NA"}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             color: "#64748b",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {row.parentMobile || "NA"}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "600",
//                             color: "#1e3a5f",
//                           }}
//                         >
//                           {row.customer_name || "NA"}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             color: "#64748b",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {row.customer_mobile || "NA"}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             color: "#334155",
//                           }}
//                         >
//                           {row.project_name || "NA"}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             color: "#64748b",
//                           }}
//                         >
//                           {row.blockNo}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "600",
//                             color: "#1e3a5f",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {row.unitNo}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "700",
//                             color: "#1e5799",
//                             textAlign: "right",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {parseFloat(row.unitSqyd).toFixed(2)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "600",
//                             color: "#334155",
//                           }}
//                         >
//                           {row.associateName}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             color: "#64748b",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {row.associateMobile}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             textAlign: "center",
//                             fontWeight: "700",
//                             color: "#7c3aed",
//                           }}
//                         >
//                           {row.levelNo}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "700",
//                             color: "#dc2626",
//                             textAlign: "right",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {parseFloat(row.oldSqyd).toFixed(2)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "700",
//                             color: "#d97706",
//                             textAlign: "right",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {parseFloat(row.unitSqyd).toFixed(2)}
//                         </td>
//                         <td
//                           style={{
//                             padding: "10px",
//                             fontWeight: "700",
//                             color: "#059669",
//                             textAlign: "right",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {parseFloat(row.new_sqyd).toFixed(2)}
//                         </td>
//                         <td style={{ padding: "10px" }}>
//                           <span
//                             style={{
//                               display: "inline-block",
//                               padding: "4px 10px",
//                               borderRadius: "20px",
//                               fontSize: "10.5px",
//                               fontWeight: "700",
//                               background:
//                                 row.type === "Direct Sale"
//                                   ? "#e7f9eb"
//                                   : "#e8f1fb",
//                               color:
//                                 row.type === "Direct Sale"
//                                   ? "#059669"
//                                   : "#1e5799",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {row.type}
//                           </span>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             {/* Empty State */}
//             {!loading && searchDetails && tableData.length === 0 && (
//               <div style={{ textAlign: "center", padding: "60px 20px" }}>
//                 <div
//                   style={{
//                     width: "80px",
//                     height: "80px",
//                     borderRadius: "20px",
//                     background: "#fef3e2",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     margin: "0 auto 20px",
//                     fontSize: "36px",
//                     color: "#d97706",
//                   }}
//                 >
//                   ⚠️
//                 </div>
//                 <h4
//                   style={{
//                     color: "#1e3a5f",
//                     fontWeight: "800",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   No Transactions Found
//                 </h4>
//                 <p
//                   style={{ color: "#64748b", fontSize: "13.5px", margin: 0 }}
//                 >
//                   No transaction data found for this mobile number
//                 </p>
//               </div>
//             )}

//             {/* Initial Empty State */}
//             {!loading && !searchDetails && tableData.length === 0 && (
//               <div style={{ textAlign: "center", padding: "60px 20px" }}>
//                 <div
//                   style={{
//                     width: "80px",
//                     height: "80px",
//                     borderRadius: "20px",
//                     background: "#e8f1fb",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     margin: "0 auto 20px",
//                     fontSize: "36px",
//                     color: "#1e5799",
//                   }}
//                 >
//                   <FaSearch />
//                 </div>
//                 <h4
//                   style={{
//                     color: "#1e3a5f",
//                     fontWeight: "800",
//                     marginBottom: "8px",
//                   }}
//                 >
//                   Search to View Ledger
//                 </h4>
//                 <p
//                   style={{ color: "#64748b", fontSize: "13.5px", margin: 0 }}
//                 >
//                   Enter a mobile number above to view the SQYD ledger
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//         @media (max-width: 768px) {
//           .summary-grid-responsive {
//             grid-template-columns: repeat(2, 1fr) !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default UnitSQYDLedger;
import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import {
  FaPhoneAlt,
  FaSearch,
  FaFileDownload,
  FaUserFriends,
  FaHandshake,
  FaShoppingCart,
  FaChartBar,
} from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL;

// ✅ Utility: clean unit number (removes trailing dash/spaces)
const cleanUnitNo = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[-\s]+$/, "").trim();
};

function UnitSQYDLedger() {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchDetails, setSearchDetails] = useState(null);
  const [summary, setSummary] = useState(null);

  // ✅ Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getAuthToken = () => localStorage.getItem("token");

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    if (dateStr.includes("-")) {
      const parts = dateStr.split("-");
      if (
        parts[0].length === 2 &&
        parts[1].length === 2 &&
        parts[2].length === 4
      ) {
        return `${parts[0]}/${parts[1]}/${parts[2]}`;
      }
    }
    try {
      const date = new Date(dateStr);
      if (!isNaN(date)) {
        return date.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }
    } catch (e) {
      return dateStr;
    }
    return dateStr;
  };

  const fetchData = async (e) => {
    e.preventDefault();
    if (!mobile) {
      Swal.fire("Missing Input", "Please enter a mobile number", "warning");
      return;
    }

    setLoading(true);
    setTableData([]);
    setSearchDetails(null);
    setSummary(null);
    setCurrentPage(1); // reset page

    try {
      const token = getAuthToken();
      const response = await axios.get(
        `${API_URL}/myteam-tree-with-sales?mobile=${mobile}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.status === "1") {
        setSearchDetails(response.data.search_details);

        const apiSummary = response.data.summary || {};
        setSummary({
          total_users_in_tree: apiSummary.total_users || 0,
          users_with_transactions: apiSummary.users_with_transactions || 0,
          total_direct_sales: 0,
          total_commissions: 0,
        });

        const formattedData = [];
        const userData = response.data.user_data;

        if (
          userData &&
          userData.transactions &&
          userData.transactions.all_transactions
        ) {
          const allTransactions = userData.transactions.all_transactions;
          let directSalesCount = 0;
          let commissionsCount = 0;

          allTransactions.forEach((transaction) => {
            const isSelf = transaction.entry_type === "self";
            const isTeam = transaction.entry_type === "team";

            if (isSelf) directSalesCount++;
            if (isTeam) commissionsCount++;

            const transactionDate =
              transaction.date ||
              transaction.display_date ||
              transaction.lead_date ||
              new Date().toISOString().split("T")[0];

            formattedData.push({
              srNo: formattedData.length + 1,
              parentName: userData.parent_username || "-",
              parentMobile: userData.parent_mobile || "-",
              project_name: transaction.project_name || "-",
              blockNo: transaction.block_name || "-",
              unitNo: transaction.unit_no || "-",
              unitSqyd: transaction.plot_area || "0.00",
              associateName: transaction.child_username || "-",
              associateMobile: transaction.child_mobile || "-",
              customer_name: transaction.customer_name || "-",
              customer_mobile: transaction.customer_mobile || "-",
              levelNo: userData.level_in_tree || 0,
              oldSqyd: transaction.old_sqyd || 0,
              new_sqyd: transaction.new_sqyd || 0,
              currentSqyd: transaction.plot_area || 0,
              totalSqyd: transaction.new_sqyd || 0,
              date: transactionDate,
              type: isSelf ? "Direct Sale" : "Commission",
              entryType: transaction.entry_type,
            });
          });

          setSummary((prev) => ({
            ...prev,
            total_direct_sales: directSalesCount,
            total_commissions: commissionsCount,
          }));
        }

        const sortedData = [...formattedData].sort((a, b) => {
          const valA = parseFloat(a.new_sqyd) || 0;
          const valB = parseFloat(b.new_sqyd) || 0;
          return valA - valB;
        });

        setTableData(sortedData);
      } else {
        Swal.fire("No Data", response.data.message || "No data found", "info");
      }
    } catch (error) {
      console.error("Data fetch error:", error);
      Swal.fire(
        "Warning !!!",
        "Sorry No Data Found Please Try Another.",
        "info"
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ Excel download with clean unit no
  const downloadExcel = () => {
    if (tableData.length === 0) {
      Swal.fire("No Data", "No data available to download", "warning");
      return;
    }

    const excelData = tableData.map((row, index) => ({
      "Sr No": index + 1,
      Date: row.date,
      "Parent Name": row.parentName,
      "Parent Mobile": row.parentMobile || "NA",
      "Project Name": row.project_name,
      "Block No": row.blockNo || "NA",
      "Unit No": cleanUnitNo(row.unitNo) || "NA",
      "Unit SQYD": parseFloat(row.unitSqyd).toFixed(2),
      "Associate Name": row.associateName,
      "Associate Mobile": row.associateMobile,
      "Customer Name": row.customer_name || "NA",
      "Customer Mobile": row.customer_mobile || "NA",
      "Level No": row.levelNo,
      "Old SQYD": parseFloat(row.oldSqyd).toFixed(2),
      "Current SQYD": parseFloat(row.unitSqyd).toFixed(2),
      "Total SQYD": parseFloat(row.new_sqyd).toFixed(2),
      "Transaction Type": row.type,
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Unit SQYD Ledger");
    const fileName = `Unit_SQYD_Ledger_${mobile}_${
      new Date().toISOString().split("T")[0]
    }.xlsx`;
    XLSX.writeFile(wb, fileName);
    Swal.fire("Success", "Excel file downloaded successfully!", "success");
  };

  const summaryCards = summary
    ? [
        {
          label: "Total Users",
          value: summary.total_users_in_tree,
          icon: <FaUserFriends />,
          color: "#1e5799",
          bg: "#e8f1fb",
        },
        {
          label: "With Transactions",
          value: summary.users_with_transactions,
          icon: <FaHandshake />,
          color: "#d97706",
          bg: "#fef3e2",
        },
        {
          label: "Direct Sales",
          value: summary.total_direct_sales,
          icon: <FaShoppingCart />,
          color: "#059669",
          bg: "#e7f9eb",
        },
        {
          label: "Commissions",
          value: summary.total_commissions,
          icon: <FaChartBar />,
          color: "#7c3aed",
          bg: "#f3e8ff",
        },
      ]
    : [];

  // ✅ Pagination calculations
  const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // scroll to table top
      const tableEl = document.getElementById("ledger-table-top");
      if (tableEl) {
        tableEl.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // ✅ Pagination group (smart ellipsis)
  const getPaginationGroup = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 3) {
      return [1, 2, 3, 4, "...", totalPages];
    }
    if (currentPage >= totalPages - 2) {
      return [
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }
    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient Bar */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                <FaChartBar />
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Unit SQYD Ledger Report
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Search by mobile number to view SQYD transactions
                </p>
              </div>
            </div>

            {tableData.length > 0 && (
              <button
                onClick={downloadExcel}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                  boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 24px rgba(5, 150, 105, 0.45)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 18px rgba(5, 150, 105, 0.3)";
                }}
              >
                <FaFileDownload style={{ fontSize: "14px" }} />
                Download Excel
              </button>
            )}
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Search Form */}
            <form
              onSubmit={fetchData}
              style={{
                background: "#f8fafc",
                borderRadius: "14px",
                padding: "18px",
                marginBottom: "24px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-end",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ flex: 1, minWidth: "240px" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "12.5px",
                      fontWeight: "700",
                      color: "#1e3a5f",
                      marginBottom: "6px",
                    }}
                  >
                    Mobile Number <span style={{ color: "#dc2626" }}>*</span>
                  </label>
                  <div style={{ position: "relative" }}>
                    <span
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#1e5799",
                        fontSize: "14px",
                        pointerEvents: "none",
                      }}
                    >
                      <FaPhoneAlt />
                    </span>
                    <input
                      type="text"
                      placeholder="Enter 10-digit mobile number"
                      value={mobile}
                      onChange={(e) =>
                        setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
                      }
                      style={{
                        width: "100%",
                        padding: "11px 14px 11px 38px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        fontSize: "13.5px",
                        fontWeight: "500",
                        color: "#1e3a5f",
                        outline: "none",
                        boxSizing: "border-box",
                        transition: "all 0.25s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#1e5799";
                        e.target.style.boxShadow =
                          "0 0 0 4px rgba(30,87,153,0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e2e8f0";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    padding: "11px 30px",
                    borderRadius: "10px",
                    border: "none",
                    background: loading
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    color: "#ffffff",
                    fontSize: "13.5px",
                    fontWeight: "700",
                    cursor: loading ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                    transition: "all 0.25s ease",
                    height: "44px",
                  }}
                >
                  {loading ? (
                    <>
                      <span
                        style={{
                          width: "14px",
                          height: "14px",
                          border: "2px solid rgba(255,255,255,0.3)",
                          borderTop: "2px solid #ffffff",
                          borderRadius: "50%",
                          display: "inline-block",
                          animation: "spin 0.8s linear infinite",
                        }}
                      />
                      Loading...
                    </>
                  ) : (
                    <>
                      <FaSearch style={{ fontSize: "13px" }} />
                      Show Details
                    </>
                  )}
                </button>
              </div>
            </form>

            {/* Search Details */}
            {searchDetails && (
              <div
                style={{
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  borderRadius: "14px",
                  padding: "16px 22px",
                  marginBottom: "20px",
                  color: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  flexWrap: "wrap",
                  boxShadow: "0 8px 24px rgba(30, 87, 153, 0.25)",
                }}
              >
                <div
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "12px",
                    background: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  👤
                </div>
                <div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "11px",
                      opacity: 0.85,
                      fontWeight: "600",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    Search Result
                  </p>
                  <h5
                    style={{
                      margin: "2px 0 0",
                      fontSize: "16px",
                      fontWeight: "800",
                    }}
                  >
                    {searchDetails.username || "NA"} —{" "}
                    {searchDetails.mobile || "NA"}
                    {searchDetails.has_transactions && (
                      <span
                        style={{
                          marginLeft: "10px",
                          fontSize: "11px",
                          padding: "3px 10px",
                          borderRadius: "20px",
                          background: "rgba(255,255,255,0.25)",
                          fontWeight: "700",
                        }}
                      >
                        ✓ Has Transactions
                      </span>
                    )}
                  </h5>
                </div>
              </div>
            )}

            {/* Summary Cards — Responsive Grid */}
            {summary && (
              <div
                className="summary-grid-responsive"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "14px",
                  marginBottom: "24px",
                }}
              >
                {summaryCards.map((card, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#ffffff",
                      borderRadius: "14px",
                      padding: "18px",
                      border: "1.5px solid #e2e8f0",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 12px 28px rgba(30, 87, 153, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 14px rgba(30, 87, 153, 0.06)";
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "4px",
                        height: "100%",
                        background: card.color,
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <p
                          style={{
                            fontSize: "11.5px",
                            fontWeight: "700",
                            color: "#64748b",
                            margin: 0,
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {card.label}
                        </p>
                        <h3
                          style={{
                            fontSize: "24px",
                            fontWeight: "800",
                            color: card.color,
                            margin: "8px 0 0",
                            letterSpacing: "-0.5px",
                          }}
                        >
                          {card.value}
                        </h3>
                      </div>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "10px",
                          background: card.bg,
                          color: card.color,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "18px",
                          flexShrink: 0,
                        }}
                      >
                        {card.icon}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* ✅ Table + Top Pagination Info */}
            {tableData.length > 0 && (
              <>
                <div id="ledger-table-top" />

                {/* Top bar: rows per page + info */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "13px",
                      color: "#64748b",
                      fontWeight: "600",
                    }}
                  >
                    Show
                    <select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                      style={{
                        padding: "6px 10px",
                        borderRadius: "8px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#1e3a5f",
                        cursor: "pointer",
                        outline: "none",
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    entries
                  </div>

                  <div
                    style={{
                      fontSize: "13px",
                      color: "#64748b",
                      fontWeight: "600",
                    }}
                  >
                    Showing{" "}
                    <strong style={{ color: "#1e5799" }}>
                      {indexOfFirstRow + 1}
                    </strong>{" "}
                    to{" "}
                    <strong style={{ color: "#1e5799" }}>
                      {Math.min(indexOfLastRow, tableData.length)}
                    </strong>{" "}
                    of{" "}
                    <strong style={{ color: "#1e5799" }}>
                      {tableData.length}
                    </strong>{" "}
                    entries
                  </div>
                </div>

                {/* Table */}
                <div
                  style={{
                    overflowX: "auto",
                    borderRadius: "14px",
                    border: "1.5px solid #e2e8f0",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "12.5px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        }}
                      >
                        {[
                          "Sr No",
                          "Date",
                          "Parent Name",
                          "Parent Mobile",
                          "Customer Name",
                          "Customer Mobile",
                          "Project",
                          "Block",
                          "Unit",
                          "Unit SQYD",
                          "Associate Name",
                          "Associate Mobile",
                          "Level",
                          "Old SQYD",
                          "Current SQYD",
                          "Total SQYD",
                          "Type",
                        ].map((th, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "12px 10px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11px",
                              textAlign: "left",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {currentRows.map((row, index) => (
                        <tr
                          key={index}
                          style={{
                            borderBottom: "1px solid #f1f5f9",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "700",
                              color: "#1e5799",
                            }}
                          >
                            {indexOfFirstRow + index + 1}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              color: "#64748b",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {formatDate(row.date)}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "600",
                              color: "#1e3a5f",
                            }}
                          >
                            {row.parentName || "NA"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              color: "#64748b",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.parentMobile || "NA"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "600",
                              color: "#1e3a5f",
                            }}
                          >
                            {row.customer_name || "NA"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              color: "#64748b",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.customer_mobile || "NA"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              color: "#334155",
                            }}
                          >
                            {row.project_name || "NA"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              color: "#64748b",
                            }}
                          >
                            {row.blockNo}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "600",
                              color: "#1e3a5f",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {/* ✅ Clean Unit No */}
                            {cleanUnitNo(row.unitNo) || "NA"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "700",
                              color: "#1e5799",
                              textAlign: "right",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {parseFloat(row.unitSqyd).toFixed(2)}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "600",
                              color: "#334155",
                            }}
                          >
                            {row.associateName}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              color: "#64748b",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.associateMobile}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              textAlign: "center",
                              fontWeight: "700",
                              color: "#7c3aed",
                            }}
                          >
                            {row.levelNo}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "700",
                              color: "#dc2626",
                              textAlign: "right",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {parseFloat(row.oldSqyd).toFixed(2)}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "700",
                              color: "#d97706",
                              textAlign: "right",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {parseFloat(row.unitSqyd).toFixed(2)}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              fontWeight: "700",
                              color: "#059669",
                              textAlign: "right",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {parseFloat(row.new_sqyd).toFixed(2)}
                          </td>
                          <td style={{ padding: "10px" }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "10.5px",
                                fontWeight: "700",
                                background:
                                  row.type === "Direct Sale"
                                    ? "#e7f9eb"
                                    : "#e8f1fb",
                                color:
                                  row.type === "Direct Sale"
                                    ? "#059669"
                                    : "#1e5799",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {row.type}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* ✅ Bottom Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      ‹ Prev
                    </button>

                    {getPaginationGroup().map((p, i) => {
                      if (p === "...") {
                        return (
                          <span
                            key={`ellipsis-${i}`}
                            style={{
                              padding: "0 6px",
                              color: "#94a3b8",
                              fontWeight: "700",
                            }}
                          >
                            ...
                          </span>
                        );
                      }
                      const isActive = p === currentPage;
                      return (
                        <button
                          key={p}
                          onClick={() => handlePageChange(p)}
                          style={{
                            minWidth: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            border: isActive
                              ? "none"
                              : "1.5px solid #e2e8f0",
                            background: isActive
                              ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                              : "#ffffff",
                            color: isActive ? "#ffffff" : "#334155",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            boxShadow: isActive
                              ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                              : "none",
                            transition: "all 0.18s ease",
                          }}
                        >
                          {p}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                )}

                {/* Bottom info */}
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    color: "#94a3b8",
                    marginTop: "12px",
                    marginBottom: 0,
                    fontWeight: "500",
                  }}
                >
                  Page {currentPage} of {totalPages} • {tableData.length} total
                  records
                </p>
              </>
            )}

            {/* Empty State — Search Done But No Data */}
            {!loading && searchDetails && tableData.length === 0 && (
              <div style={{ textAlign: "center", padding: "60px 20px" }}>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "20px",
                    background: "#fef3e2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px",
                    fontSize: "36px",
                    color: "#d97706",
                  }}
                >
                  ⚠️
                </div>
                <h4
                  style={{
                    color: "#1e3a5f",
                    fontWeight: "800",
                    marginBottom: "8px",
                  }}
                >
                  No Transactions Found
                </h4>
                <p
                  style={{ color: "#64748b", fontSize: "13.5px", margin: 0 }}
                >
                  No transaction data found for this mobile number
                </p>
              </div>
            )}

            {/* Initial Empty State */}
            {!loading && !searchDetails && tableData.length === 0 && (
              <div style={{ textAlign: "center", padding: "60px 20px" }}>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "20px",
                    background: "#e8f1fb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px",
                    fontSize: "36px",
                    color: "#1e5799",
                  }}
                >
                  <FaSearch />
                </div>
                <h4
                  style={{
                    color: "#1e3a5f",
                    fontWeight: "800",
                    marginBottom: "8px",
                  }}
                >
                  Search to View Ledger
                </h4>
                <p
                  style={{ color: "#64748b", fontSize: "13.5px", margin: 0 }}
                >
                  Enter a mobile number above to view the SQYD ledger
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @media (max-width: 992px) {
          .summary-grid-responsive {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 576px) {
          .summary-grid-responsive {
            grid-template-columns: repeat(1, 1fr) !important;
          }
        }
      `}</style>
    </div>
  );
}

export default UnitSQYDLedger;